module.exports = __webpack_public_path__ + "media/resources/assets/images/membership-resources/fpa-connect-webinars.png";